import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  message: '',
  open: false,
  type: 'success',
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (state, action) => {
      state.open = action.payload.open !== undefined ? action.payload.open : true;
      state.message = action.payload.message || state.message;
      state.type = action.payload.type || state.type;
    },
    hideToast: (state) => {
      state.open = false;
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;

export default toastSlice.reducer;
